import { render } from "./adminDeleteConfirmation.vue?vue&type=template&id=f9575644&scoped=true"
import script from "./adminDeleteConfirmation.vue?vue&type=script&lang=js"
export * from "./adminDeleteConfirmation.vue?vue&type=script&lang=js"

import "./adminDeleteConfirmation.vue?vue&type=style&index=0&id=f9575644&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9575644"]])

export default __exports__